import { Link, Outlet, useLocation } from "react-router";
import { User, KeyRound, CreditCard, FolderOpen } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSuretyMode } from "@/hooks/useSuretyMode";

const DOCUMENTS_PATH = "/settings/documents";

const navItems = [
  { path: "/settings/account", label: "Cuenta", icon: User },
  { path: DOCUMENTS_PATH, label: "Documentos", icon: FolderOpen },
  { path: "/settings/api-keys", label: "API Keys", icon: KeyRound },
  { path: "/settings/plan", label: "Plan", icon: CreditCard },
];

export default function SettingsLayout() {
  const { pathname } = useLocation();
  // Los documentos son para el cruce de requisitos, que Fianzas no tiene.
  const isSurety = useSuretyMode();
  const visibleNavItems = isSurety
    ? navItems.filter((item) => item.path !== DOCUMENTS_PATH)
    : navItems;

  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col p-6 md:p-8">
      {/* Page header */}
      <div className="mb-8">
        <h1 className="text-2xl font-extrabold tracking-tight text-slate-800 dark:text-slate-100">
          Configuración
        </h1>
        <p className="mt-1 text-sm text-slate-400 dark:text-slate-500">
          Administra tu cuenta y preferencias
        </p>
      </div>

      <div className="flex flex-col items-start gap-6 md:flex-row">
        {/* Sidebar nav (card) */}
        <nav className="flex w-full shrink-0 flex-row gap-1 rounded-2xl border border-slate-100 bg-white p-2 shadow-sm dark:border-slate-800 dark:bg-slate-900 md:w-52 md:flex-col">
          {visibleNavItems.map((item) => {
            const active = pathname.includes(item.path);
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "flex items-center gap-3 rounded-xl border border-transparent px-3.5 py-2.5 text-sm font-semibold transition-all",
                  active
                    ? "border-primary/50 bg-primary/5 text-primary"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200",
                )}
              >
                <Icon className="size-[18px] shrink-0" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Content */}
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
